import { ReactComponent as EmployeesSvg } from "../../assets/images/svgs/employees.svg";

const EmployeesIcon = ({ className = "", ...props }) => {
  return (
    <EmployeesSvg
      className={className}
      focusable="false"
      aria-hidden="true"
      {...props}
    />
  );
};

export default EmployeesIcon;
